import { createFileRoute } from '@tanstack/react-router';

import { CampaignOverviewPage } from '../features/campaigns/campaigns/components/CampaignOverviewPage';
import { lineItemsRouteSearchSchema } from '../features/campaigns/campaigns/lineItemsRouteSearch';

export const Route = createFileRoute('/campaigns/campaigns_/overview/$campaignId')({
  validateSearch: lineItemsRouteSearchSchema,
  component: CampaignOverviewRoute,
});

function CampaignOverviewRoute() {
  const { campaignId } = Route.useParams();
  return <CampaignOverviewPage campaignId={campaignId} />;
}
